import { PageHeader } from "@/components/shared/page-header";
import { useSession } from "@/lib/auth-client";

export function ProfilePage() {
  const { data: session } = useSession();
  return (
    <div className="space-y-6">
      <PageHeader title="Profile" description="Your account details." />
      {session?.user && (
        <div className="rounded-lg border p-6 space-y-2 text-sm">
          <div>
            <span className="font-medium">Name: </span>
            {session.user.name}
          </div>
          <div>
            <span className="font-medium">Email: </span>
            {session.user.email}
          </div>
          <div>
            <span className="font-medium">Role: </span>
            {session.user.role}
          </div>
        </div>
      )}
    </div>
  );
}
